/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_Seo_DescInputs */

const en_notes_seo_desc = /** @type {(inputs: Notes_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes on modern tech, developer tooling, system design, and cross-platform development.`)
};

const ar_notes_seo_desc = /** @type {(inputs: Notes_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملاحظات عن التقنيات الحديثة، وأدوات المطورين، وتصميم الأنظمة، والتطوير متعدد المنصات.`)
};

const bn_notes_seo_desc = /** @type {(inputs: Notes_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আধুনিক টেক, ডেভেলপার টুলিং, সিস্টেম ডিজাইন এবং ক্রস-প্ল্যাটফর্ম ডেভেলপমেন্ট নিয়ে নোট।`)
};

const de_notes_seo_desc = /** @type {(inputs: Notes_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notizen zu moderner Technologie, Entwicklertools, Systemdesign und plattformübergreifender Entwicklung.`)
};

const es_notes_seo_desc = /** @type {(inputs: Notes_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas sobre tecnología moderna, herramientas para desarrolladores, diseño de sistemas y desarrollo multiplataforma.`)
};

const fr_notes_seo_desc = /** @type {(inputs: Notes_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes sur la technologie moderne, les outils de développement, la conception de systèmes et le développement multiplateforme.`)
};

const pt_notes_seo_desc = /** @type {(inputs: Notes_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas sobre tecnologia moderna, ferramentas para desenvolvedores, design de sistema e desenvolvimento multiplataforma.`)
};

const zh_notes_seo_desc = /** @type {(inputs: Notes_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于现代技术、开发者工具、系统设计和跨平台开发的笔记。`)
};

const tr_notes_seo_desc = /** @type {(inputs: Notes_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modern teknoloji, geliştirici araçları, sistem tasarımı ve cross-platform geliştirme üzerine notlar.`)
};

const ru_notes_seo_desc = /** @type {(inputs: Notes_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заметки о современных технологиях, инструментах разработчика, проектировании систем и кроссплатформенной разработке.`)
};

const pl_notes_seo_desc = /** @type {(inputs: Notes_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notatki o nowoczesnych technologiach, narzędziach deweloperskich, projektowaniu systemów i rozwoju cross-platformowym.`)
};

/**
* | output |
* | --- |
* | "Notes on modern tech, developer tooling, system design, and cross-platform development." |
*
* @param {Notes_Seo_DescInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const notes_seo_desc = /** @type {((inputs?: Notes_Seo_DescInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_Seo_DescInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_notes_seo_desc(inputs)
	if (locale === "bn") return bn_notes_seo_desc(inputs)
	if (locale === "de") return de_notes_seo_desc(inputs)
	if (locale === "es") return es_notes_seo_desc(inputs)
	if (locale === "fr") return fr_notes_seo_desc(inputs)
	if (locale === "pt") return pt_notes_seo_desc(inputs)
	if (locale === "zh") return zh_notes_seo_desc(inputs)
	if (locale === "tr") return tr_notes_seo_desc(inputs)
	if (locale === "ru") return ru_notes_seo_desc(inputs)
	if (locale === "pl") return pl_notes_seo_desc(inputs)
	return en_notes_seo_desc(inputs)
});